module.exports = __webpack_public_path__ + "static/media/pic.2eaf8b11.png";